(() => {
  const initializeTabs = (root, tabSelector, panelSelector) => {
    if (!root || root.dataset.mcReady === 'true') return;
    root.dataset.mcReady = 'true';
    const tabs = [...root.querySelectorAll(tabSelector)];
    const panels = [...root.querySelectorAll(panelSelector)];

    const activate = (tab, focus = false) => {
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;
        if (focus && selected) item.focus();
      });
      panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
        activate(tabs[(index + direction + tabs.length) % tabs.length], true);
      });
    });
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-mc-goals]').forEach((root) => initializeTabs(root, '[data-mc-goal-tab]', '[data-mc-goal-panel]'));
    scope.querySelectorAll('[data-mc-tech]').forEach((root) => initializeTabs(root, '[data-mc-tech-tab]', '[data-mc-tech-panel]'));
    scope.querySelectorAll('[data-mc-routine]').forEach((root) => initializeTabs(root, '[data-mc-routine-tab]', '[data-mc-routine-panel]'));

    scope.querySelectorAll('[data-mc-mewing]').forEach((root) => {
      if (root.dataset.mcReady === 'true') return;
      root.dataset.mcReady = 'true';
      const items = [...root.querySelectorAll('[data-mc-feature]')];
      items.forEach((item) => item.addEventListener('click', () => {
        const expanded = item.getAttribute('aria-expanded') === 'true';
        items.forEach((candidate) => candidate.setAttribute('aria-expanded', 'false'));
        item.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      }));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
